import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gift, Share2, Copy } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Chip } from "@/components/ui-bits";

const STATUS = { new: ["warn", "waiting on coach"], converted: ["ok", "joined · reward added"], dismissed: ["gray", "didn't join"] };

export const ReferFriend = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/client/me/referral").then((r) => setD(r.data)).catch(() => setD(false)); }, []);
  if (!d || !d.enabled) return null;
  const text = `Come train with me at ${d.studioName} — sign up here: ${d.link}`;
  const copy = () => { navigator.clipboard?.writeText(d.link); toast.success("Link copied — send it to a friend"); };
  const share = async () => { if (navigator.share) { try { await navigator.share({ title: `Train with me at ${d.studioName}`, text, url: d.link }); } catch { /* dismissed */ } } else copy(); };
  const reward = d.rewardSessions > 0 ? `${d.rewardSessions} free session${d.rewardSessions !== 1 ? "s" : ""}` : "a thank-you from your coach";
  return (
    <div className="panel" data-testid="refer-friend-card">
      <div className="ph"><h3><Gift size={16} style={{ verticalAlign: -3, marginRight: 6 }} />Refer a friend · earn {reward}</h3>{d.earned > 0 && <span className="chip ok num" data-testid="referral-earned">{d.earned} earned</span>}</div>
      <p className="ss" style={{ marginTop: 0 }}>Share your link. When your friend joins {d.studioName}, {d.rewardSessions > 0 ? `${d.rewardSessions} free session${d.rewardSessions !== 1 ? "s" : ""} land${d.rewardSessions === 1 ? "s" : ""} in your account automatically.` : "your coach will thank you personally."}</p>
      <div className="msg" data-testid="referral-link-box"><div className="who"><span>Your link · code {d.code}</span></div><div className="txt" style={{ wordBreak: "break-all", fontSize: 13 }} data-testid="referral-link">{d.link}</div></div>
      <div className="actions" style={{ marginTop: 10 }}>
        <button className="btn sm" onClick={share} data-testid="referral-share-button"><Share2 size={14} style={{ verticalAlign: -2, marginRight: 6 }} />Share</button>
        <button className="btn sm g" onClick={copy} data-testid="referral-copy-button"><Copy size={14} style={{ verticalAlign: -2, marginRight: 6 }} />Copy link</button>
      </div>
      {d.referrals.length > 0 && (
        <div style={{ marginTop: 12 }} data-testid="referral-list">
          {d.referrals.map((r, i) => <div className="kv" key={i} data-testid={`referral-row-${i}`}><span>{r.name} <span className="ss">· {fmtDate(r.createdAt)}</span></span><Chip cls={STATUS[r.status]?.[0]} label={STATUS[r.status]?.[1] || r.status} /></div>)}
        </div>
      )}
    </div>
  );
};
